import './progress-circular.component.scss';

export default {
  template: require('./progress-circular.component.html'),
  bindings: {
    value: '<?vuiValue',
    _diameter: '<?vuiDiameter',
    _stroke: '<?vuiStroke',
    _color: "@?vuiColor"
  },
  controller: function ($scope) {
    'ngInject';

    const self = $scope.$ctrl;

    this.$onInit = () => {
      self.diameter = self._diameter || 48;
      self.stroke = self._stroke || 4;
      self.color = self._color || '#FFD400';

      self.radius = self.diameter / 2;
      self.normalizedRadius = self.radius - self.stroke / 2;
      self.circumference = 2 * Math.PI * self.normalizedRadius;

      update();
    }

    const update = () => {
      if (angular.isNumber(self.value)) {
        self.isIndeterminate = false;
        const percent = Math.max(0, Math.min(100, self.value));
        self.dashOffset = self.circumference - percent / 100 * self.circumference;
      } else {
        self.isIndeterminate = true;
        self.dashOffset = 0;
      }
    }

    $scope.$watch('value', update);
  }
};
